define('application',['jquery', 'utilities', 'storage', 'logging'], function($, utilities, storage, logging) {
    var _ModuleName = 'Angular Application Interface';

    var _config = {
        params: {
            offerData: 'od',
            processVersion: 'pv'
        },
        events: {
            lead: 'iframe_message_register_lead',
            complete: 'iframe_message_complete',
            impression: 'iframe_message_register_impression'
        },
        api: {
            endpoints: {
                leads: '/public/api/v2.0/leads',
                impressions: '/public/api/v2.0/leads/:leadId/pages/:pageId/impressions',
                offerImpressions: '/public/api/v2.0/offers/:offerId/impressions',
                pendingImpressions: '/public/api/v2.0/offers/:offerId/pending-impressions',
                optoutByOffer: '/public/api/v2.0/offers/:offerId/optouts/:email',
                optoutByList: '/public/api/v2.0/optouts/:listId/:email',
                globalParams: '/public/api/v2.0/params',
                phoneValidation: '/public/api/v2.0/validations/phone/:phoneNumber',
                addressValidation: '/public/api/v2.0/validations/address',
                emailValidation: '/public/api/v2.0/validations/email/:email',
                facebookconversions: '/public/api/v2.0/facebookconversions',
            }
        }
    };

    const storageSessionFrameConfigKey = 'storage-session-frame-config';

    var getMessageTargetHost = function() {
        var config = getFrameConfigData();
        if (config) {
            return config.messageRecipientOrigin;
        }
        return '';
    };

    /**
     * Submit impressions based on offer ids
     * @param {Array} offerIds a list of offer ids
     */
    var submitImpressionByOfferIds = function(offerIds) {
        // generate our endpoint url
        var frameConfig = getFrameConfigData();
        var endpoint = getApiEndpointHost() + _config.api.endpoints.impressions;

        endpoint = endpoint.replace(':leadId', frameConfig.lead.id);
        endpoint = endpoint.replace(':pageId', frameConfig.pageId);

        // Create impressions array to submit 
        var impressions = [];

        var rsid = getRSID();
        if (!rsid) {
            rsid = generateRSID();
            setSessionTrackingData('rsid', rsid)
            logging.debug('Generated new RSID for impressions by offer ids: ' + rsid, _ModuleName);
        }

        // add in the impressions based on offerid
        for (var idx = 0; idx < offerIds.length; idx++) {
            // make sure we have a number
            if (isNaN(offerIds[idx])) {
                logging.error('Offer id is not a valid number', offerIds[idx]);
                continue;
            }

            // add in the impression offer id
            impressions.push({
                offerId: offerIds[idx],
                accepted: true,
                data: "",
                parameters: frameConfig.parameters,
                rsid: frameConfig.rsid,
                pendingImpressionId: 0
            });
        }

        // submit the data
        logging.debug('Submitting Lead data to ' + endpoint, _ModuleName);
        $.ajax({
            url: endpoint,
            method: 'POST',
            data: JSON.stringify(impressions),
            dataType: 'json',
            jsonp: false,
            processData: false,
            contentType: 'application/json',
            error: function(jqXHR, textStatus, errorThrown) {
                logging.error('Something went wrong submitting impression.', _ModuleName);
                logging.error('Response: ' + jqXHR.responseText, _ModuleName);
                logging.error('Status Returned: ' + textStatus, _ModuleName);
                logging.error('Error Message: ' + errorThrown, _ModuleName);
            }
        });
    };

    /**
     * Submit impression to CoRegServer then notify parent application when complete
     * @param {Dom Object} $form form object from dom as a jquery variable
     * @param {function} completeFn a function to run when complete. runs even when there is a failure
     */
    var submitImpression = function($form, completeFn, notifyParentAppOnly) {
        // default notifyParentAppOnly to false
        if (typeof notifyParentAppOnly === 'undefined') { notifyParentAppOnly = false; }

        var serializedData = "";
        
        // make sure we got some data
        if (typeof $form != 'undefined' && $form != null) {
            // filter out hidden input fields and serialize the data
            serializedData = _serializeForm($form);
        }

        logging.debug('Submitting Impression: ' + serializedData, _ModuleName);

        // generate our endpoint url
        var frameConfig = getFrameConfigData();
        var endpoint = getApiEndpointHost() + _config.api.endpoints.impressions;

        endpoint = endpoint.replace(':leadId', frameConfig.lead.id);
        endpoint = endpoint.replace(':pageId', frameConfig.pageId);

        var rsid = getRSID();
        if (!rsid) {
            rsid = generateRSID();
            setSessionTrackingData('rsid', rsid)
            logging.debug('Generated new RSID for impression: ' + rsid, _ModuleName);
        }

        // Create impressions array to submit 
        var impressions = [
            {
                offerId: frameConfig.offerId,
                accepted: true,
                data: serializedData,
                parameters: frameConfig.parameters,
                rsid: rsid,
                pendingImpressionId: frameConfig.pendingImpressionId
            }
        ];

        if (notifyParentAppOnly) {
            logging.debug('notifying parent application of impression (not actually submitted)', _ModuleName);
            notifyParentOfImpression(impressions);

            if (typeof completeFn == 'function') {
                logging.debug('Running requested completion function', _ModuleName);
                completeFn();
            }
        } else {
            // submit the data
            logging.debug('Submitting Lead data to ' + endpoint, _ModuleName);
            $.ajax({
                url: endpoint,
                method: 'POST',
                data: JSON.stringify(impressions),
                dataType: 'json',
                jsonp: false,
                processData: false,
                contentType: 'application/json',
                error: function(jqXHR, textStatus, errorThrown) {
                    logging.error('Something went wrong submitting impression.', _ModuleName);
                    logging.error('Response: ' + jqXHR.responseText, _ModuleName);
                    logging.error('Status Returned: ' + textStatus, _ModuleName);
                    logging.error('Error Message: ' + errorThrown, _ModuleName);
                },
                success: function(storedImpressions) {
                    logging.debug('Lead submission was successfull, notifying parent application', _ModuleName);
                    notifyParentOfImpression(storedImpressions);
                },
                complete: function() {
                    if (typeof completeFn == 'function') {
                        logging.debug('Running requested completion function', _ModuleName);
                        completeFn();
                    }
                }
            });
        }
    };

    /**
     * Check if we have a lead id
     * @returns {boolean} true if we have a lead id, false otherwise
     */
    var hasLead = function() {
        var frameConfig = getFrameConfigData();
        return frameConfig && frameConfig.lead && frameConfig.lead.id;
    }

    // Function to generate RSID if not found in the URL
    var generateRSID = function() {
        const brandName = utilities.getBrandNameFromDomain();
        const brandSegment = brandName.slice(0, 1).toUpperCase();
        const numericSegment = Math.floor(100 + Math.random() * 900); // 3-digit random number
        const alphanumericSegment = utilities.randomString(12); // 12-character alphanumeric string
        return brandSegment + numericSegment + alphanumericSegment;
    }

    var submitPendingImpression = function ($offerId) {
        clearSessionTrackingData();
        // generate our endpoint url
        var endpoint = getApiEndpointHost() + _config.api.endpoints.pendingImpressions;
        endpoint = endpoint.replace(':offerId', $offerId);
        const eventSourceUrl = window.location.origin + window.location.pathname;

        var rsid = getRSID();
        if (!rsid) {
            rsid = generateRSID();
            setSessionTrackingData('rsid', rsid)
            logging.debug('Generated new RSID for pending impression: ' + rsid, _ModuleName);
        }
        setSessionTrackingData('rsid', rsid)
        const matchedParameters = getMatchedParameters();
        // Create impressions array to submit 
        var impressions = {
                id: 0,
                leadId: 0,
                pageId: 0,
                offerId: $offerId,
                parameters: matchedParameters ? matchedParameters : [],
                rsid: rsid,
                metaData:
                    [{ id: 0, type: 3, value: "UnbouncePage" }, { id: 0, type: 2, value: eventSourceUrl }]
                };
        
        // submit the data
        logging.debug('Submitting pending Impression to ' + endpoint, _ModuleName);
        $.ajax({
            url: endpoint,
            method: 'POST',
            data: JSON.stringify(impressions),
            dataType: 'json',
            jsonp: false,
            processData: false,
            contentType: 'application/json',
            error: function (jqXHR, textStatus, errorThrown) {
                logging.error('Something went wrong submitting impression.', _ModuleName);
                logging.error('Response: ' + jqXHR.responseText, _ModuleName);
                logging.error('Status Returned: ' + textStatus, _ModuleName);
                logging.error('Error Message: ' + errorThrown, _ModuleName);
            },
            success: function (storedPendingImpression) {
                logging.debug('Pending impresson is submitted', _ModuleName);
                setSessionTrackingData('pendingImpressionId', storedPendingImpression.id)
            }
        });
    }

    var submitSingleOfferImpression = function ($form, $offerId, completeFn) {
        return new Promise(function (resolve, reject) {
            var serializedData = "";

            if (typeof $form !== 'undefined' && $form != null) {
                serializedData = _serializeForm($form);
            }

            logging.debug('Submitting Impression: ' + serializedData, _ModuleName);
            const matchedParameters = getMatchedParameters();
            var endpoint = getApiEndpointHost() + _config.api.endpoints.offerImpressions;
            endpoint = endpoint.replace(':offerId', $offerId);

            const sessionTrackingData = storage.getSessionStorage('SessionTrackingData') || {};
            var pendingImpressionId = sessionTrackingData.pendingImpressionId;
            var lead = sessionTrackingData.submittedLead;
            var rsid = getRSID();
            if (!rsid) {
                rsid = generateRSID();
                setSessionTrackingData('rsid', rsid)
                logging.debug('Generated new RSID for single offer impression: ' + rsid, _ModuleName);
            }            

            var impressions = {
                offerId: $offerId,
                accepted: true,
                data: serializedData,
                parameters: matchedParameters ? matchedParameters : [],
                rsid: rsid,
                pendingImpressionId: pendingImpressionId,
                lead: lead 
            };

            logging.debug('Submitting Lead data to ' + endpoint, _ModuleName);
            $.ajax({
                url: endpoint,
                method: 'POST',
                data: JSON.stringify(impressions),
                dataType: 'json',
                jsonp: false,
                processData: false,
                contentType: 'application/json',
                success: function (storedImpressions) {
                    logging.debug('Impression submission was successful', _ModuleName);
                    clearSessionTrackingData();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    logging.error('Something went wrong submitting impression.', _ModuleName);
                    logging.error('Response: ' + jqXHR.responseText, _ModuleName);
                    logging.error('Status Returned: ' + textStatus, _ModuleName);
                    logging.error('Error Message: ' + errorThrown, _ModuleName);
                },
                complete: function () {
                    if (typeof completeFn == 'function') {
                        logging.debug('Running requested completion function', _ModuleName);
                        completeFn();
                    }
                }
            });
        });
    };

    /**
     * Check if we are running in a path
     * @returns {boolean} true if we are running in a path, false otherwise
     */
    var runningInAPath = function() {
        var config = getFrameConfigData();
        return config && config.pageId && config.pageId > 0;
    }

    function getGlobalParameters() {
        const sessionTrackingData = storage.getSessionStorage('SessionTrackingData') || {};

        if (!sessionTrackingData.globalParams) {
            // Fetch global parameters and store them in session
            var endpoint = getApiEndpointHost() + _config.api.endpoints.globalParams;
            $.ajax({
                url: endpoint,
                method: 'GET',
                jsonp: false,
                processData: false,
                contentType: 'application/json',
                success: function (params) {
                    setSessionTrackingData('globalParams', params);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    logging.error('Error fetching global parameters.', _ModuleName);
                }
            });
        }
    }

    // Modify getMatchedParameters to handle the async result from getGlobalParameters
    var getMatchedParameters = function () {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionTrackingData = storage.getSessionStorage('SessionTrackingData') || {};
        const globalParams = sessionTrackingData.globalParams || [];  // Retrieve directly from session

        const matchedParameters = globalParams.map(function(param) {
            const value = urlParams.get(param.key);
            return value !== null ? { key: param.key, value: value } : null;
        }).filter(function(item) { 
            return item !== null; 
        }); // Filter out null entries

        return matchedParameters;
    };

    var setSessionTrackingData = function (field, value) {
        // Retrieve the current pending impression data or create a new object if not set
        const sessionTrackingData = storage.getSessionStorage('SessionTrackingData') || {};
        // Update the specified field with the new value
        sessionTrackingData[field] = value;
        // Save the updated object back to session storage
        storage.setSessionStorage('SessionTrackingData', sessionTrackingData);
    }

    function clearSessionTrackingData() {
        sessionStorage.removeItem('bnet-regpath-storage-SessionTrackingData');
        // storage.removeSessionStorage('SessionTrackingData'); 
    }
    /**
     * Check if we are running in pathfinder
     * @returns returns true if we are running in pathfinder
     */
    var runningInPathfinder = function() {
        var frameConfig = getFrameConfigData();
        return frameConfig != null && Object.keys(frameConfig).length > 0;
    }

    /**
     * Submit lead to CoRegServer then notify parent application when complete
     * @param {string} firstName First Name of lead
     * @param {string} lastName Last Name of lead
     * @param {string} email Email Address of lead
     * @param {string} zip Zip Code of lead
     * @param {string} phone Phone number of lead
     * @param {function} completeFn a function to run when complete. runs even when there is a failure
     * @param {boolean} enablePlaceholderEmail if true, will generate a placeholder email when one is not provided
     */
    var submitLead = function(firstName, lastName, email, zip, phone, completeFn, enablePlaceholderEmail) {
        // Default enablePlaceholderEmail to false if not provided
        enablePlaceholderEmail = enablePlaceholderEmail === true;
        
        // if we already have a lead in the frame config, we don't need to submit a new lead
        if (hasLead()) {
            logging.debug('Lead id already exists, skipping lead submission', _ModuleName);
            if (typeof completeFn == 'function') {
                logging.debug('Running requested completion function', _ModuleName);
                completeFn();
            }
            return;
        } 

        if (typeof email == 'undefined' || email == null || email == '') {
            var config = getFrameConfigData();
            // if we already have a lead id, this is not needed
            if (config && config.lead && config.lead.id) {
                logging.debug('Lead id already exists, skipping email lookup', _ModuleName);
                if (typeof completeFn == 'function') {
                    logging.debug('Running requested completion function', _ModuleName);
                    completeFn();
                }
            } 
            // if we have an email but no id, we still need to do the lookup for the full record
            else if (config && config.lead && config.lead.email) {
                email = config.lead.email;
            }
        }

        // Get rsid from frame config or session
        var rsid = getRSID();

        // Email is required, but use placeholder if enabled and email not provided
        if ((typeof email == 'undefined' || email == null || email == '') && enablePlaceholderEmail) {
            logging.debug('No email provided, using placeholder email', _ModuleName);
            // If no rsid found, generate one
            if (!rsid) {
                rsid = generateRSID();
                logging.debug('Generated new RSID for placeholder email: ' + rsid, _ModuleName);
            }
            // Create placeholder email using rsid
            email = rsid + '@placeholder-email.com';
            logging.debug('Using placeholder email: ' + email, _ModuleName);
        } else if (typeof email == 'undefined' || email == null || email == '') {
            logging.error('Unable to submit lead. Email is required and placeholder emails are not enabled.', _ModuleName);
            return;
        }

        // configure data object
        var data = {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            Zip: zip,
            Phone: phone,
            RSID: rsid
        };

        logging.debug('Submitting lead data: ' + JSON.stringify(data), _ModuleName);

        // generate endpoint url
        var endpoint = getApiEndpointHost() + _config.api.endpoints.leads;

        // submit lead to endpoint
        logging.debug('Submitting Lead data to ' + endpoint, _ModuleName);

        $.ajax({
            url: endpoint,
            method: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            jsonp: false,
            processData: false,
            contentType: 'application/json',
            error: function(jqXHR, textStatus, errorThrown) {
                logging.error('Something went wrong submitting lead.', _ModuleName);
                logging.error('Response: ' + jqXHR.responseText, _ModuleName);
                logging.error('Status Returned: ' + textStatus, _ModuleName);
                logging.error('Error Message: ' + errorThrown, _ModuleName);
            },
            success: function(lead) {
                logging.debug('Lead submission was successfull, notifying parent application', _ModuleName);
                notifyParentOfLead(lead);
                addLeadToFrameConfigData(lead);
                setSessionTrackingData('submittedLead', lead)
            },
            complete: function() {
                if (typeof completeFn == 'function') {
                    logging.debug('Running requested completion function', _ModuleName);
                    completeFn();
                }
            }
        });
    };

    /**
     * Submits a Facebook event to the server-side endpoint.
     * @param {Object} event - The Facebook event data.
     * @param {string} eventSourceUrl - The URL where the event originated.
     * @returns {Promise<Object>} - The response data from the server.
     */
    var createFacebookEvent = function(event, eventSourceUrl) {
        return new Promise(function(resolve, reject) {
            event.eventSourceUrl = eventSourceUrl || (window.location.origin + window.location.pathname);
            event.userAgent = window.navigator.userAgent;
            const brandName = utilities.getBrandNameFromDomain();
            var endpoint = getApiEndpointHost() + _config.api.endpoints.facebookconversions + '/'+brandName+'/event';
            $.ajax({
                url: endpoint,
                method: 'POST',
                data: JSON.stringify(event),
                contentType: 'application/json',
                success: function(response) {
                    resolve(response);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    logging.error('Error submitting Facebook event.', _ModuleName);
                    logging.error('Response: ' + jqXHR.responseText, _ModuleName);
                    logging.error('Status Returned: ' + textStatus, _ModuleName);
                    logging.error('Error Message: ' + errorThrown, _ModuleName);
                    reject(errorThrown);
                }
            });
        });
    };

    /**
     * Gets process version being used by checking query parameters
     * Defaults to 1.0
     */
    var getProcessVersionNumber = function() {
        // if we're running in Pathfinder, just assume v2.0 
        if (runningInPathfinder()) { return '2.0'; }

        var version = utilities.getParameter(document.URL, _config.params.processVersion);
        if (version) {
            logging.debug('Application Process Version Number: ' + version, _ModuleName);
            return version;
        }

        logging.debug('Application Process Version Number: 1.0', _ModuleName);
        return '1.0';
    };

    /**
     * Gets impression submission data passed through the URL from the parent application
     * Defaults to an empty object with no data
     */
    var _frameConfigData = null;
    var getFrameConfigData = function() {
        logging.debug('Get Frame Config Data');
        if (_frameConfigData == null) {
            var data = utilities.getParameter(document.URL, _config.params.offerData);
            if (data) {
                var decodedData = atob(data);
                if (decodedData) {
                    logging.debug('Impression Submission Data: ' + decodedData, _ModuleName);
                    _frameConfigData = JSON.parse(decodedData);
                } else {
                    logging.debug('Had trouble decoding impression submission data.', _ModuleName);
                    _frameConfigData = {};
                }
            } else {
                // frame config not found in url, attempt to rehydrate from storage
                rehydrateFrameConfig();
                if (_frameConfigData == null) {
                    logging.debug('Impression Submission Data not found in request.', _ModuleName);
                    _frameConfigData = {};
                }
            }
        }

        return _frameConfigData;
    };

    var storeFrameConfigInSessionStorage = function() {
        logging.debug('Store frame config in session storage');

        var frameConfig = this.getFrameConfigData();
        if (frameConfig == null) {
            logging.error('No frame config found. Unable to store in session.');
            return;
        }

        // check if we have already stored a value
        var currentSessionFrameConfig = storage.getSessionStorage(storageSessionFrameConfigKey);
        if (currentSessionFrameConfig) {
            logging.debug('found current frame config in storage override', currentSessionFrameConfig);
        }
        // store in session storage
        if (storage.setSessionStorage(storageSessionFrameConfigKey, frameConfig)) {
            logging.debug('stored current frame config in storage', storageSessionFrameConfigKey, frameConfig);
        } else {
            logging.debug('could not stor current frame config in storage', storageSessionFrameConfigKey, frameConfig);
        }
    }

    var rehydrateFrameConfig = function() {
        logging.debug('Rehydrate Frame Config');

        // get data from storage
        var currentSessionFrameConfig = storage.getSessionStorage(storageSessionFrameConfigKey);

        // store in _frameConfigData
        if (currentSessionFrameConfig) {
            _frameConfigData = currentSessionFrameConfig;
            logging.debug('found current frame config in storage', currentSessionFrameConfig);
        }
    }

    var clearFrameConfigFromSessionStorage = function() {
        logging.debug('Clearing frame config from session storage');

        // clear our key from session storage
        if (storage.removeSessionStorage(storageSessionFrameConfigKey)) {
            logging.debug('removed current frame config in storage', storageSessionFrameConfigKey);
        }
    }

    var addLeadToFrameConfigData = function(lead) {
        // if frame config data hasn't been parsed yet, parse it
        if (_frameConfigData == null) {
            this.getFrameConfigData();
        }
        
        // update with new lead
        _frameConfigData.lead = lead;
    }

    var getLeadData = function() {
        // if frame config data hasn't been parsed yet, parse it
        if (_frameConfigData == null) {
            this.getFrameConfigData();
        }

        return _frameConfigData.lead;
    }

    var getOfferId = function() {
        // if frame config data hasn't been parsed yet, parse it
        if (_frameConfigData == null) {
            this.getFrameConfigData();
        }

        return _frameConfigData.offerId;
    }

    var getBrandName = function() {
        // if frame config data hasn't bee parsed yet, parse it
        if (_frameConfigData == null) {
            this.getFrameConfigData();
        }

        return _frameConfigData.brandName || '';
    }

    var getTrackedParameterKeys = function() {
        // if frame config data hasn't bee parsed yet, parse it
        if (_frameConfigData == null) {
            this.getFrameConfigData();
        }

        if (_frameConfigData != null && _frameConfigData.parameters != null) {
            return _frameConfigData.parameters.map(function(p) { return p.key; });
        }

        return [];
    }

    var getTrackedParameterValue = function(parameterName) {
        // check url for track1
        var parameterValue = utilities.getParameter(document.URL, parameterName);
        if (parameterValue) { return parameterValue; }

        // if frame config data hasn't bee parsed yet, parse it
        if (_frameConfigData == null) {
            this.getFrameConfigData();
        }

        // check frame config data for track1 parameter
        var parameter = _frameConfigData.parameters.find(function(p) { return p.key === parameterValue });
        if (parameter && parameter.value) {
            return parameter.value;
        }

        return '';
    }
    
    /**
     * Gets the current API Host that was passed in from parent application
     */
    var getApiEndpointHost = function() {
        var data = getFrameConfigData();
        return data.apiEndpointHost || 'https://cr.beliefnet.com';
    }

    /**
     * Notify parent application of impression that was sent
     * @param {Impression[]} impression array of impression objects that holds data for a given impressions
     */
    var notifyParentOfImpression = function(impressions) {
        logging.debug('Notifying parent of impression', _ModuleName);
        if (impressions) {
            parent.window.postMessage({ messageType: 'register_impression', messageData: impressions }, getMessageTargetHost());
            logging.debug('Message Sent', _ModuleName);
        } else {
            logging.debug('Invalid impression data. Event not raised.', _ModuleName);
        }
    };

    /**
     * Notify parent applicate user wants to skip offer
     */
    var notifyParentOfSkip = function() {
        logging.debug('Notifying parent of skip', _ModuleName);
        parent.window.postMessage({ messageType: 'skip_offer', messageData: null }, getMessageTargetHost());
        logging.debug('Message Sent', _ModuleName);
    }

    /**
     * Check if we are running in a stand alone offer
     * @returns {boolean} true if we are running in a stand alone offer, false otherwise
     */
    var isStandAloneOffer = function() {
        // check url for stand_alone_offer=true
        return utilities.getParameter(document.URL, 'stand_alone_offer') === 'true';
    }

    /**
     * Notify parent application of lead that was sent
     * @param {Lead} lead lead object that holds data for a given lead
     */
    var notifyParentOfLead = function(lead) {
        logging.debug('Notifying parent of lead', _ModuleName);
        if (lead) {
            parent.window.postMessage({ messageType: 'register_lead', messageData: lead }, getMessageTargetHost());
            logging.debug('Message Sent', _ModuleName);
        } else {
            logging.debug('Invalid lead data. Event not raised.', _ModuleName);
        }
    };

    /**
     * Notify parent application we are complete and ready for propogation
     */
    var notifyParentComplete = function(destination) {
        logging.debug('Notifying parent of completion', _ModuleName);
        parent.window.postMessage({ messageType: 'complete', messageData: destination }, getMessageTargetHost());
        logging.debug('Message Sent', _ModuleName);
    };

    /**
     * Notify parent application we are complete and ready for propogation, with impression data
     * @param {Impression} impressionData impression data to send to parent application
     */
    var notifyParentCompleteWithImpression = function ($form) {
        logging.debug('Notifying parent of completion with impression', _ModuleName);
        parent.window.postMessage({ messageType: 'complete', messageData: { impressionSubmitted: false, impressionData: _getFormData($form) } }, getMessageTargetHost());
        logging.debug('Message Sent', _ModuleName);
    };

    var notifyParentOfFrameHeightUpdate = function(height) {
        logging.debug('Notifying parent of frame height update', _ModuleName);
        parent.window.postMessage({ messageType: 'register_height', messageData: height }, getMessageTargetHost());
        logging.debug('Message Sent', _ModuleName);
    }

    /**
     * Check lead opt out by offer
     * @param {String} email Email address to check. If not provided, will pull off lead record on frame data if available
     * @param {Number} offerId Offer id to check. If not provided, will pull off frame config if available
     * @param {Function} successFn Function to run after successful API call. Will include boolean as parameter set to true if user has opted out, false otherwise
     * @param {Function} completeFn Function to run after API call is completed (whether success or otherwise)
     */
    var checkOptOutByOffer = function(email, offerId, successFn, completeFn) {
        // if email not provided, try getting off frame config data for lead (this won't work for signup pages)
        if (!email) {
            var lead = getLeadData();
            if (lead && lead.email) {
                email = lead.email;
            }
        }

        // if offer id not provided, try getting off frame config data for current page offer 
        if (!offerId){
            offerId = getOfferId();
        }

        if (email && offerId) {

            var endpoint = getApiEndpointHost() + _config.api.endpoints.optoutByOffer;

            endpoint = endpoint.replace(':offerId', offerId);
            endpoint = endpoint.replace(':email', lead.email);

            $.ajax({
                url: endpoint,
                method: 'GET',
                jsonp: false,
                processData: false,
                contentType: 'application/json',
                error: function(jqXHR, textStatus, errorThrown) {
                    logging.error('Something went wrong submitting impression.', _ModuleName);
                    logging.error('Response: ' + jqXHR.responseText, _ModuleName);
                    logging.error('Status Returned: ' + textStatus, _ModuleName);
                    logging.error('Error Message: ' + errorThrown, _ModuleName);
                },
                success: function(result) {
                    logging.debug('Offer optout check was successful', _ModuleName);
                    if (typeof successFn == 'function') {
                        logging.debug('Running requested completion function', _ModuleName);
                        successFn(result.optOut);
                    }
                },
                complete: function() {
                    if (typeof completeFn == 'function') {
                        logging.debug('Running requested completion function', _ModuleName);
                        completeFn();
                    }
                }
            });
        }
    }

    /**
     * Check lead opt out by list id
     * @param {String} email Email address to check. If not provided, will pull off lead record on frame data if available
     * @param {Number} optOutListId Opt Out List id to check.
     * @param {Function} successFn Function to run after successful API call. Will include boolean as parameter set to true if user has opted out, false otherwise
     * @param {Function} completeFn Function to run after API call is completed (whether success or otherwise)
     */
    var checkOptOutByListId = function(email, optOutListId, successFn, completeFn) {
        // if email not provided, try getting off frame config data for lead (this won't work for signup pages)
        if (!email) {
            console.debug('Email not provided, attempting to pull lead data');
            var lead = getLeadData();
            if (lead && lead.email) {
                console.debug('Email found in lead data');
                email = lead.email;
            }
        }

        if (email && optOutListId) {

            var endpoint = getApiEndpointHost() + _config.api.endpoints.optoutByList;

            endpoint = endpoint.replace(':listId', optOutListId);
            endpoint = endpoint.replace(':email', email);

            $.ajax({
                url: endpoint,
                method: 'GET',
                jsonp: false,
                processData: false,
                contentType: 'application/json',
                error: function(jqXHR, textStatus, errorThrown) {
                    logging.error('Something went wrong submitting impression.', _ModuleName);
                    logging.error('Response: ' + jqXHR.responseText, _ModuleName);
                    logging.error('Status Returned: ' + textStatus, _ModuleName);
                    logging.error('Error Message: ' + errorThrown, _ModuleName);
                },
                success: function(result) {
                    logging.debug('optout by list check was successful', _ModuleName);
                    if (typeof successFn == 'function') {
                        logging.debug('Running requested completion function', _ModuleName);
                        successFn(result.optOut);
                    }
                },
                complete: function() {
                    if (typeof completeFn == 'function') {
                        logging.debug('Running requested completion function', _ModuleName);
                        completeFn();
                    }
                }
            });
        }
    }

    /**
     * Converts form values to a JSON object, then serializes it
     * @param {jQuery Object} $form Form object
     */
    var _serializeForm = function($form) {
        var formArray = $form.find(':input').serializeArray();
        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
            returnArray[formArray[i]['name']] = formArray[i]['value'];
        }
        return JSON.stringify(returnArray);
    };

    /**
     * Converts form values to a JSON object
     * @param {jQuery Object} $form Form object
     */
    var _getFormData = function ($form) {
        var formArray = $form.find(':input').serializeArray();
        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
            returnArray[formArray[i]['name']] = formArray[i]['value'];
        }
        return returnArray;
    };

    /**
     * Validate phone number
     * @param {String} phoneNumber Phone number to validate
     * @param {String} countryCode Country code to validate
     * @returns {Promise} Promise object
     */
    function validatePhoneNumber(phoneNumber, countryCode) {
        return new Promise(function(resolve, reject) {
            var endpoint = getApiEndpointHost() + _config.api.endpoints.phoneValidation;
            endpoint = endpoint.replace(':phoneNumber', phoneNumber);
            if (countryCode) {
                endpoint += '?countryCode=' + encodeURIComponent(countryCode);
            }
            $.ajax({
                url: endpoint,
                method: 'GET',
                success: function(response) {
                    if (response.result === 'Success' && response.valid) {
                        resolve();
                    } else if (response.result === 'Success' && !response.valid) {
                        reject('Invalid phone number');
                    } else if (response.result !== 'Success' && response.message) {
                        reject(response.message);
                    } else {
                        reject('Error validating phone number');
                    }
                },
                error: function() {
                    reject('Error validating phone number');
                }
            });
        });
    }

    /**
     * Validate address
     * @param {String} address Address to validate
     * @param {String} city City to validate
     * @param {String} state State to validate
     * @param {String} zip Zip code to validate
     * @returns {Promise} Promise object
     */
    function validateAddress(address, city, state, zip) {
        return new Promise(function(resolve, reject) {
            const endpoint = getApiEndpointHost() + _config.api.endpoints.addressValidation;
            const data = {
                address: address,
                city: city,
                state: state,
                zip: zip
            };
            $.ajax({
                url: endpoint,
                method: 'POST',
                data: JSON.stringify(data),
                contentType: 'application/json',
                success: function(response) {
                    if (response.result === 'Success' && response.valid) {
                        resolve(response);
                    } else if (response.result === 'Success' && !response.valid) {
                        reject('Invalid address');
                    } else if (response.result !== 'Success' && response.message) {
                        reject(response.message);
                    } else {
                        reject('Error validating address');
                    }
                },
                error: function() {
                    reject('Error validating address');
                }
            });
        });
    }

    /**
     * Validate email
     * @param {String} email Email to validate
     * @returns {Promise} Promise object
     */
    function validateEmail(email) {
        return new Promise(function(resolve, reject) {
            var endpoint = getApiEndpointHost() + _config.api.endpoints.emailValidation;
            endpoint = endpoint.replace(':email', email);
            $.ajax({
                url: endpoint,
                method: 'GET',
                contentType: 'application/json',
                success: function(response) {
                    if (response.result === 'Success' && response.valid) {
                        resolve();
                    } else if (response.result === 'Success' && !response.valid) {
                        reject('Invalid email');
                    } else if (response.result !== 'Success' && response.message) {
                        reject(response.message);
                    } else {
                        reject('Error validating email');
                    }
                },
                error: function() {
                    reject('Error validating email');
                }
            });
        });
    }

    function getRSID() {
        // Check for rsid in URL
        const rsidFromUrl = utilities.getParameter(document.URL, 'rsid');
        if (rsidFromUrl) {
            return rsidFromUrl;
        }

        // Check for rsid in session storage
        const sessionTrackingData = storage.getSessionStorage('SessionTrackingData');
        if (sessionTrackingData && sessionTrackingData.rsid) {
            return sessionTrackingData.rsid;
        }

        // Check for rsid in frame config
        if (_frameConfigData && _frameConfigData.rsid) {
            return _frameConfigData.rsid;
        }

        return null;
    }

    
        

    return {
        getProcessVersionNumber: getProcessVersionNumber,
        getFrameConfigData: getFrameConfigData,
        notifyParentOfImpression: notifyParentOfImpression,
        notifyParentOfLead: notifyParentOfLead,
        notifyParentComplete: notifyParentComplete,
        notifyParentCompleteWithImpression: notifyParentCompleteWithImpression,
        submitLead: submitLead,
        submitImpression: submitImpression,
        submitSingleOfferImpression: submitSingleOfferImpression,
        notifyParentOfFrameHeightUpdate: notifyParentOfFrameHeightUpdate,
        getLeadData: getLeadData,
        getBrandName: getBrandName,
        notifyParentOfSkip: notifyParentOfSkip,
        storeFrameConfigInSessionStorage: storeFrameConfigInSessionStorage,
        rehydrateFrameConfig: rehydrateFrameConfig,
        clearFrameConfigFromSessionStorage: clearFrameConfigFromSessionStorage,
        runningInPathfinder: runningInPathfinder,
        getTrackedParameterValue: getTrackedParameterValue,
        getTrackedParameterKeys: getTrackedParameterKeys,
        submitImpressionByOfferIds: submitImpressionByOfferIds,
        getOfferId: getOfferId,
        checkOptOutByOffer: checkOptOutByOffer,
        checkOptOutByListId: checkOptOutByListId,
        getRSID: getRSID,
        submitPendingImpression: submitPendingImpression,
        getGlobalParameters: getGlobalParameters,
        validatePhoneNumber: validatePhoneNumber,
        validateAddress: validateAddress,
        validateEmail: validateEmail,
        getRSID: getRSID,
        generateRSID: generateRSID,
        hasLead: hasLead,
        isStandAloneOffer: isStandAloneOffer,
        runningInAPath: runningInAPath,
        createFacebookEvent: createFacebookEvent
    };
});

